import template from './storyCard.html';
import controller from './storyCardController';

function storyCard() {
  return {
    restrict: 'E',
    scope: {
      story: '=',
      singleView: '=',
      useCase: '@'
    },
    template,
    controller: 'StoryCardController'
  };
}

export default function (ngModule) {
  ngModule.directive('storyCard', [storyCard]);
  controller(ngModule);
}
